import React, { useState, } from 'react'
import {useDispatch, useSelector} from 'react-redux';
import './CopyModal.css'
import {setJoinModalType} from "../../../../store/reducers/SessionReducer";
import whatsapp from '../../../../assets/images/whatsapp-logo.png'

function CopyModal() {
  const { scheduledSessionLink, roomLink } = useSelector(state => state.participant);
  const dispatch = useDispatch()

  const [copied, setCopiedState] = useState(null)
    const [shareWhatsapp, setShareWhatsapp] = useState(null);

  const copyLink = () => {
    const el = document.createElement('textarea');
    el.value = roomLink;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    setCopiedState(true)

    setTimeout(() => {
        setCopiedState(false)
        dispatch(setJoinModalType(null))
    }, 600)
  };

  const shareWhatsApp = () => {

     const whatsapp = "https://web.whatsapp.com/send?" + `text=${roomLink}`

      setShareWhatsapp(true)
      try {
          window.open(whatsapp, '_blank')
      }catch (e){
          console.log('whats app is not found')
      }
      setTimeout(() => {
          setShareWhatsapp(false)
          dispatch(setJoinModalType(null))
      }, 600)

  }

  return (
    <div className='cm-container'>
      <div className='cm-title'>
          Teile den Link mit deinen Freunden!
      </div>

      <div
        className='cm-link'
        onClick={copyLink}
      >
        {roomLink}
      </div>
        <div>
      <button 
        className={`cm-button ${copied ? 'active' : ''}`}
        onClick={copyLink}
      >
        {copied ? (
          'Kopiert!'
        ) : (
          'Link kopieren'
        )}
      </button>
        <button
        className={`cm-button ${shareWhatsapp ? 'active' : ''}`}
        onClick={() => shareWhatsApp()
        }
        >
            <img className={'watsapp-icon'} src={whatsapp}/>
            TEILEN
        </button>
        </div>
        <a id={'test-listener'} style={{display: 'none'}} href={`whatsapp://send?text=${roomLink}`}></a>
    </div>
  )
}

export default CopyModal
